import { atom } from 'recoil';

import { ReportGeneratorListItemNormalized } from './types';

export const reportGeneratorDocumentTypeState = atom<string | undefined>({
  key: 'reportGeneratorDocumentTypeState',
  default: undefined,
});

export const reportGeneratorPeriodState = atom<string | undefined>({
  key: 'reportGeneratorPeriodState',
  default: undefined,
});

export const reportGeneratorCategoryState = atom<string | undefined>({
  key: 'reportGeneratorCategoryState',
  default: undefined,
});

export const reportGeneratorCatalogCategoryFilterState = atom<string>({
  key: 'reportGeneratorCatalogCategoryFilterState',
  default: 'all',
});

export const reportGeneratorReferenceDateState = atom<Date | undefined>({
  key: 'reportGeneratorReferenceDateState',
  default: undefined,
});

export const reportGeneratorAdditionalParametersState = atom<Record<string, string>>({
  key: 'reportGeneratorAdditionalParametersState',
  default: {},
});

export const reportGeneratorRequestPartnerIdState = atom<number | undefined>({
  key: 'reportGeneratorRequestPartnerIdState',
  default: undefined,
});

export const reportGeneratorRequestAdvisorIdState = atom<number | undefined>({
  key: 'reportGeneratorRequestAdvisorIdState',
  default: undefined,
});

export const reportGeneratorRequestLoadingState = atom<boolean>({
  key: 'reportGeneratorRequestLoadingState',
  default: false,
});

export const reportGeneratorRecentSameReportState = atom<
  ReportGeneratorListItemNormalized | undefined
>({
  key: 'reportGeneratorRecentSameReportState',
  default: undefined,
});
